// unique prefix (by comp name) need for case if id will be used in dome
export function helperCreateId(prefix?: string): string {
  return (prefix || '') + String(Math.ceil(Math.random() * 10000000)); // temp. uuid ?
}
